<template>
    <div class="dropdown-menu mt-4 p-0 dpMenu">
        <div class="cropspage__items__dropdown">
            <div class="row">
                <h4 class="font-bold font-sm margin_top_md caps_upper">Farming Stages</h4>
            </div>
            <div class="row">
                <label class="checkbox-inline control-label" v-for="(stage, index) in stages" :key="index">
                    <farming-stage-row :stage="stage" @stageValue="stageValue" />
                </label>
                <!-- <label class="checkbox-inline control-label">
                    <input type="checkbox" class="checkbox">
                    <span class="label_title ">Planting</span>
                </label> -->
            </div>
        </div>
    </div>
</template>

<script>
import FarmingStageRow from './FarmingStageRow';

export default {
    props: [],
    data() {
        return {
            values: [],
            stages: [],
            gettingFarmStages: false
        }
    },
    methods: {
        stageValue(value) {
            if(this.values.includes(value)) {
                const index = this.values.findIndex(item => item === value)
                this.values.splice(index, 1)
            } else {
                this.values.push(value)
            }
            this.$emit('stageValues', this.values)
        },
        getStages() {
          this.gettingFarmStages = true;
          this.$http
            .get("farms/stages")
            .then(response => {
              this.stages = response.data;
              this.gettingFarmStages = false;
            })
            .catch(error => {
              this.gettingFarmStages = false;
              this.$toastr.error(error);
            });
        },
    },
    created() {
        this.getStages();
    },
    components: {
        FarmingStageRow
    }
}
</script>

<style>

</style>